import NavBar from "../generalComponents/NavBar";
import {useState} from "react";
import JobListView from "./components/JobListView";
import AllRefListView from "../CustomerLogosPage/components/AllRefListView";
import AllBlogsView from "../blogPages/blogSubComponents/AllBlogsView";
import {BriefcaseIcon, ArchiveBoxIcon} from "@heroicons/react/20/solid";
import {API_ENDPOINTS} from "../config";
import {useDivision} from "../context/DivisonContext";
import {Changelog} from "../generalComponents/Changelog";
import GoogleMapComponent from "../googleMap/googleMap";
import JobListViewNewJobs from "./components/JobListViewNewJobs";

const DashBoard = () => {
    const {division} = useDivision();

    return (
        <div>
            <NavBar/>
            <Changelog></Changelog>
            <div className="m-5">
                { division === 'HR' &&
                    <div className="mt-10 mb-5">
                    <h1 className="text-3xl font-semibold text-gray-800 flex items-center gap-2">
                        <BriefcaseIcon className="h-6 w-6"/>
                        All jobs
                    </h1>
                    <JobListViewNewJobs></JobListViewNewJobs>
                </div>
                }
                {
                division === 'Sales' &&
                <div className="mt-10 mb-5">
                    <h1 className="text-3xl font-semibold text-gray-800 flex items-center gap-2">
                        <ArchiveBoxIcon className="h-6 w-6"/>
                        All references
                    </h1>
                    <AllRefListView/>
                    <div className={"mb-40 mt-10 w-1/2 align-middle justify-center ml-auto mr-auto"}>
{/*                        <h1>Preview of the Map on the website</h1>
                        <GoogleMapComponent></GoogleMapComponent>*/}
                    </div>
                    <div className={"h-64"}>
                        
                    </div>
                </div>
                }
                { 
                division === 'Marketing' &&
                <div className="mt-10 mb-5">
                    <h1 className="text-3xl font-semibold text-gray-800 flex items-center gap-2">
                        <ArchiveBoxIcon className="h-6 w-6"/>
                        All Blogs
                    </h1>
                    <AllBlogsView/>
                </div>
                }
            </div>
        </div>
    );
}

export default DashBoard;